const modelName = 'Search Filter Colours';
const modelNameSingular = 'Search Filter Colour';
const endpoint = '/search-filter-colour';

const setup = {
    title: modelName,
    singular: modelNameSingular,
    model: modelName.replace(/\s+/g, '-').toLowerCase(),
    canDelete: true,
    canAddNew: true,
    canSearch: true,
    endpoint,
    accessor: 'id',
};

export default setup;
